"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var APP_RESULT_SUCCESS = exports.APP_RESULT_SUCCESS = "APP_RESULT_SUCCESS";
var AppResetResult_success = exports.AppResetResult_success = function AppResetResult_success(options) {
	return {
		type: APP_RESULT_SUCCESS,
		payload: options
	};
};

var AppResetResult = exports.AppResetResult = function AppResetResult(options) {
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			dispatch(AppResetResult_success(options));
			resolve();
		});
	};
};